import {db} from "../../firebase";
import firebase from "firebase/compat/app";
import {Collections} from "../collections";
import {CompanyRmStatsDocInterface} from "../../db/models/company/rmStats";

export const incrementCompanyRmStatsView = (rmId: string) => {
    if (!rmId) return Promise.reject();

    return db
        .collection(Collections.COMPANY_RM_STATS)
        .doc(rmId)
        .set(
            {
                id: rmId,
                views: firebase.firestore.FieldValue.increment(1),
            },
            {merge: true}
        );
};

export const getCompanyRmStatsById = async (ids: string[]) => {
    if (!ids) return Promise.resolve([]);

    let rmStatsRefs = ids.map((id) =>
        db.collection(Collections.COMPANY_RM_STATS).doc(id).get()
    );

    const docs = await Promise.all(rmStatsRefs);
    return docs.map((doc) => doc.exists ? doc.data() as CompanyRmStatsDocInterface : null);
};
